<div class="row animated fadeInRight" *ngIf="!mostrarFormulario">
    <!-- *GRID LISTAR SESIONES -->
    <app-lfsa-card-v2 *ngIf="!mostrarSesion" [innTemplate]="enviarTemplate" [innTemplateButton]="innTemplateButton"
        [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo">
    </app-lfsa-card-v2>
    <ng-template #innTemplateButton>
        <div class="col-md-6">
            <div class="pagetitle">
                <div class="btn-group-justified btn-group" style="float: right;">
                    <a class="btn btn-outline-success" (click)="nuevo()">
                        <i class="fa fa-plus"></i>
                        {{DAT_BTNS.agregarSesion}}</a>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #enviarTemplate>
        <ag-grid-angular class="{{diccionarioModulo.agGrid.class}}" #agGrid [ngStyle]="diccionarioModulo.agGrid.style"
            id="{{diccionarioModulo.agGrid.id}}" [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion"
            [pagination]="true" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs "
            [floatingFilter]="true" [rowSelection]="rowSelection " [rowData]="rowData "
            (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </ng-template>

    <!-- *GRID LISTAR ROLES -->
    <app-lfsa-card-v2 *ngIf="mostrarSesion" [innTemplate]="enviarTemplateForm"
        [innTemplateButton]="innTemplateButtonForm" [titulo]="'Sesiones'" [modulo]="'Admin Seguridad'"
        [tituloCard]="'Roles'">
    </app-lfsa-card-v2>
    <ng-template #innTemplateButtonForm>
    </ng-template>
    <ng-template #enviarTemplateForm>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <div class="card border-success">
                    <div class="card-body">
                        <ag-grid-angular #agGrid style="width: 100%; height: 300px; " class="ag-theme-alpine mt-3"
                            [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefsRol"
                            [floatingFilter]="true" [rowSelection]="rowSelection" [rowData]="rowDataRol"
                            (gridReady)="onGridReadyRol($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <div class="card border-success">
                    <div class="card-body">
                        <br>
                        <form [formGroup]="formularioSesion" novalidate class="form-group">
                            <div class="row">
                                <div class="form-group col-12 col-md-12">
                                    <app-lfsa-combo-box [opcion]="'descripcion'" [idOpcion]="'id'" [label]="'Roles*'"
                                        [comboBox]="cmbListRol" formControlName="rolId"
                                        [control]="formularioSesion.get('rolId')" [id]="'idRol'"></app-lfsa-combo-box>
                                </div>
                                <div class="form-group col-12 col-md-6" hidden="false">
                                    <app-lfsa-input [placeholder]="'Id'" [label]="'Id'" [id]="'id'"
                                        formControlName="sesionId" [control]="formularioSesion.get('sesionId')">
                                    </app-lfsa-input>
                                </div>
                            </div>
                            <app-lfsa-botones-formulario [formularioValido]="formularioSesion.invalid"
                                (devolverAccion)="accionesRol ( $event )" [textBoton]="DAT_BTNS.agregarRol">
                            </app-lfsa-botones-formulario>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<!-- *FORMULARIO GUARDAR SESION -->
<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateEdit"
    [innTemplateButton]="innTemplateButtonEdit" [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo"
    [tituloCard]="titulo">
</app-lfsa-card-v2>

<ng-template #innTemplateButtonEdit>
</ng-template>
<ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
            <div class="form-group col-md-4">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'application'" [idOpcion]="'application'"
                    [comboBox]="cmbAplicacion" formControlName="application" [control]="formulario.get('application')"
                    [label]="'Aplicación*'" [id]="'aplicacion'">
                </app-lfsa-combo-box>
            </div>
            <div class="form-group col-md-4">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [placeholder]="'Descripción'" [label]="'Descripción*'"
                    [id]="'descripcion'" formControlName="descripcion" [control]="formulario.get('descripcion')">
                </app-lfsa-input>
            </div>
            <div class="form-group col-md-4">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [placeholder]="'Codigo Sesión'" [label]="'Codigo Sesión*'"
                    [id]="'codSesion'" formControlName="codSesion" [control]="formulario.get('codSesion')">
                </app-lfsa-input>
            </div>
        </div>
        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones ( $event )"
            [textBoton]="textBoton"></app-lfsa-botones-formulario>
    </form>
</ng-template>
